import React from 'react';
import PropTypes from 'prop-types';

import {oeInterfaceManager} from '../../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../../react-oe/oe-interface-adapter';
import OELicensingAccessProvider from '../../../../react-oe/oe-licensing-access-provider';
import {OEFNHelpEntryType, OEFNHelpPropTypes, OEFNHelpEntryFactory} from './oe-flow-nav-help-model';
import {OEManualViewLinks, OEManualViewPropTypes} from '../../manual-view/oe-manual-view-model';
import OEIconCodes from '../../../../lib/oe-icon-codes';
import {OENavigationViewComponent} from '../../../../lib/components/oe-navigation-controller';
import OEClipboard from '../../../../lib/tools/oe-clipboard';
import OEFNElement from '../../../elements/oe-flow-nav-elements';
import OEFNHelpAdvice from './oe-fn-help-advice';
import OEFNHelpHandling from './oe-fn-help-handling';
import {OEFNHelpVideos} from './oe-fn-help-videos';
import retardUpdate from '../../../../lib/react/update-retarder';
import OEToolbox from '../../../../lib/tools/oe-toolbox';
import OEPDFModal from '../../oe-pdf-modal';
import {OETarget} from '../../../../react-oe/oe-target';
import {OEUserNotificationStyle} from '../../oe-user-notification-view';

export default class OEFNHelp extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.licensingAccess = OELicensingAccessProvider.defaultLicensingAccess();

        this.state = {
            tutorUIEnabled:             false,
            tutorIsClear:               true,
            tutorIsEnabled:             true,
            licensingAccess:            OELicensingAccessProvider.defaultLicensingAccess(),
            strings: {
                advice:                 '',
                manual:                 '',
                manualInteractive:      '',
                videos:                 '',
                help:                   '',
                tutorReset:             '',
                disableTutor:           '',
                usageRights:            '',
                licenseAgreement:       '',
                credits:                '',
                feedbackLabel:          '',
                feedbackEmail:          '',
                version:                ''
            },
            texts:                      {}
        };

        this.stringMap = {
            [OEFNHelpEntryType.advice]:                 'advice',
            [OEFNHelpEntryType.manual]:                 'manual',
            [OEFNHelpEntryType.manualInteractive]:      'manualInteractive',
            [OEFNHelpEntryType.quickStart]:             'help',
            [OEFNHelpEntryType.videoTutorials]:         'videos',
            [OEFNHelpEntryType.tutorReset]:             'tutorReset',
            [OEFNHelpEntryType.disableTutor]:           'disableTutor',
            [OEFNHelpEntryType.usageRights]:            'usageRights',
            [OEFNHelpEntryType.licenseAgreement]:       'licenseAgreement',
            [OEFNHelpEntryType.credits]:                'credits',
        };

        this.updateLanguage = this.updateLanguage.bind(this);
        this.updateTutorState = this.updateTutorState.bind(this);
        this.onUIControllerStateChanged = this.onUIControllerStateChanged.bind(this);

        this.onLicensingAccess = this.onLicensingAccess.bind(this);

        this.onPDFViewRef = this.onPDFViewRef.bind(this);

        this.onItemClick = this.onItemClick.bind(this);
        this.onItemSubClick = this.onItemSubClick.bind(this);
    }

    componentWillReceiveProps(nextProps)   {
        if(nextProps.locStringPrefix !== this.props.locStringPrefix || !OEToolbox.shallowEqual(nextProps.entries, this.props.entries, true))  {
            this.updateLanguage(nextProps);
        }
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.languageChanged, this.updateLanguage);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.tutorStateChanged, this.updateTutorState);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.tutorIsClearStateChanged, this.updateTutorState);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.uiControllerStateChanged, this.onUIControllerStateChanged);
    }

    onRelease()    {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.languageChanged, this.updateLanguage);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.tutorStateChanged, this.updateTutorState);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.tutorIsClearStateChanged, this.updateTutorState);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.uiControllerStateChanged, this.onUIControllerStateChanged);
    }

    updateLanguage(props)   {
        if(!this.oe.isReady())  return;
        props = props || this.props;
        let si = this.oe.sharedInterface;

        let texts = {};
        props.entries.forEach((entry, i) => {
            if(!entry.stringId)   return;
            texts[i.toString()] = si.getLocalizedStringEnc(entry.stringId);
        });

        this.setState({
            strings: {
                advice:             si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_general_advice'),
                manual:             si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_manual'),
                manualInteractive:  si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_manual_interactive'),
                videos:             si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_videos'),
                help:               si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_help'),
                tutorReset:         si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_reset_tutor'),
                disableTutor:       si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_disable_tutor'),
                usageRights:        si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_usage_rights'),
                licenseAgreement:   si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_license_agreement'),
                credits:            si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_credits'),
                feedbackLabel:      si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_feedback_label'),
                feedbackEmail:      si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_feedback_email'),
                version:            si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_version'),
                copyToClipTooltip:  si.getLocalizedStringEnc('tooltip_copy_to_clipboard')
            },
            texts:                  texts
        });
    }

    updateTutorState()  {
        this.setState({
            tutorIsEnabled: this.oe.sharedInterface.getUIControllerTutor().getEnabled(),
            tutorIsClear: this.oe.sharedInterface.getUIControllerTutor().isClear()
        });
    }

    updateUIState()   {
        this.setState({
            tutorUIEnabled: this.oe.sharedInterface.getUIControllerTutor().getUIEnabled()
        });
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            return;
        }

        retardUpdate(this, () => {
            this.updateLanguage();
            this.updateTutorState();
            this.updateUIState();
        });
    }

    onUIControllerStateChanged(message, userInfo)    {
        if(userInfo.type !== this.oe.Module.UIControllerType.tutor) return;
        this.updateUIState();
    }

    isMasked(entry) {
        if(!entry.mask) return false;
        const mask = entry.mask;
        const licenseValid = !this.state.licensingAccess.isLicensing || this.state.licensingAccess.isValid;

        if(mask.licensingAccess && !mask.licensingAccess(this, entry, this.state.licensingAccess, this.oe))    return true;

        if(typeof(mask.licenseValid) === 'boolean' && mask.licenseValid !== licenseValid)   return true;

        return false;
    }

    onLicensingAccess(licensingAccess)  {
        this.setState({licensingAccess: licensingAccess});
    }

    onPDFViewRef(ref)   {
        this.pdfViewRef = ref;
    }

    textForEntry(entry, index) {
        let text = entry.string ? entry.string : (this.state.texts[index.toString()] ? this.state.texts[index.toString()] : (this.stringMap[entry.type] ? this.state.strings[this.stringMap[entry.type]] : ''));
        return text;
    }

    renderEntries() {
        let ret = [];
        let nextWithSpacer = false;
        let nextSpacerHeight;

        for(let index = 0; index < this.props.entries.length; ++index)  {
            const entry = this.props.entries[index];
            if(this.isMasked(entry) || [OEFNHelpEntryType.credits, OEFNHelpEntryType.feedback, OEFNHelpEntryType.version].includes(entry.type)) continue;

            let spacer = nextWithSpacer;
            let spacerHeight = nextSpacerHeight;
            let element;

            if(entry.type == OEFNHelpEntryType.spacer)    {

                element = (
                    <OEFNElement.Spacer
                        className={entry.className}
                        id={entry.type}
                        height={entry.height}
                    />
                );
                nextWithSpacer = false;

            } else if(entry.type == OEFNHelpEntryType.text)    {

                let style = {};
                if(entry.fontSize)  style.fontSize = entry.fontSize;
                if(entry.minHeight) style.minHeight = entry.minHeight;

                element = (
                    <OEFNElement.Block
                        className={entry.className}
                        id={entry.type}
                        style={style}
                        content={entry.string ? entry.string : this.state.texts[index.toString()]}
                        html={entry.html}
                    />
                );
                
                nextWithSpacer = false;

            } else {

                let className = OEToolbox.lowerCamelCaseToLowercaseUnderscore(entry.type, '-');
                if(entry.className) className = className + ' ' + entry.className;
        
                let enabled = true;
                let subButton;

                switch(entry.type)  {
                    case OEFNHelpEntryType.email:
                        subButton={
                            icon:               OEIconCodes.copyToClipboard,
                            tooltipClassName:   'no-modal-backdrop-blur',
                            tooltipPlacement:   'bottom',
                            tooltip:            this.state.strings.copyToClipTooltip,
                            onClick:            this.onItemSubClick
                        }
                        break;
                    /*
                    case OEFNHelpEntryType.manualInteractive:
                        enabled = this.props.target != OETarget.effigosExplorerHelp
                        break;
                    */
                    case OEFNHelpEntryType.tutorReset:
                        enabled = this.state.tutorUIEnabled && !this.state.tutorIsClear;
                        break;
                    case OEFNHelpEntryType.disableTutor:
                        enabled = this.state.tutorUIEnabled && this.state.tutorIsEnabled;
                        break;
                }

                let text = this.textForEntry(entry, index);
            
                element = (
                    <OEFNElement.Menu
                        id={entry.type}
                        className={className}
                        iconCode={entry.icon ? entry.icon : OEIconCodes.helpView[entry.type]}
                        title={text}
                        enabled={enabled}
                        subButton={subButton}
                        onClick={this.onItemClick}
                        userData={entry}
                    />
                );

                nextWithSpacer = true;
                nextSpacerHeight = entry.spacerHeight
            }

            ret.push(
                <React.Fragment key={index.toString() + '_element'}>
                    {nextWithSpacer && spacer ? <OEFNElement.Spacer height={spacerHeight !== undefined ? spacerHeight : this.props.autoSpacerHeight}/> : null}
                    {element}
                </React.Fragment>
            );
        }
        return ret;
    }

    renderCreditsEntry() {
        const index = this.props.entries.findIndex(entry => entry.type === OEFNHelpEntryType.credits);
        if(index < 0)   return null;

        let entry = this.props.entries[index];
        if(this.isMasked(entry))    return null;

        let text = this.textForEntry(this.props.entries[index], index);

        return (
            <React.Fragment>
                <OEFNElement.StdParagraphItem
                    className="credits"
                    title={text}
                    iconElementRight={
                        <img src="images/logo_effigos_white.png"/>
                    }
                />
                <OEFNElement.Spacer height="0.625em" /*10px*//>
            </React.Fragment>
        );
    }

    renderFeedbackEntry() {
        const entry = this.props.entries.find(entry => entry.type === OEFNHelpEntryType.feedback);
        if(!entry || this.isMasked(entry)) return null;

        return (
            <React.Fragment>
                <OEFNElement.Hyperlink
                    label={this.state.strings.feedbackLabel}
                    title={this.state.strings.feedbackEmail}
                    href={'mailto:' + this.state.strings.feedbackEmail}
                />
                <OEFNElement.Spacer height="1.75em" /*28px*//>
            </React.Fragment>
        );
    }

    renderVersion() {
        let entry = this.props.entries.find(entry => entry.type === OEFNHelpEntryType.version);
        if(!entry || this.isMasked(entry))  {
            if(!this.props.version && !(this.props.devFeatures && this.props.versionForDev)) return null;
            entry = {type: OEFNHelpEntryType.version};
        }

        let content = this.state.strings.version + ': ';
        content += versioning.ext.date ? versioning.ext.date  + '-': '';
        content += versioning.ext.core ? versioning.ext.core  + '-': '';
        content += versioning.ext.web ? versioning.ext.web  + '-': '';
        content += versioning.ext.resources ? versioning.ext.resources : '';

        return (
            <React.Fragment>
                <OEFNElement.Block
                    className="version"
                    id={entry.type}
                    content={content}
                />
                <OEFNElement.Spacer height="1.75em" /*28px*//>
            </React.Fragment>
        );
    }

    render() {
        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>
                <OELicensingAccessProvider moduleId={this.props.moduleId} omitUpdateOnRelease={true} onLicensingAccess={this.onLicensingAccess}/>

                <OEFNElement.View className="help">
                    {this.renderEntries()}
                    {this.renderCreditsEntry()}
                    {this.renderFeedbackEntry()}
                    {this.renderVersion()}
                </OEFNElement.View>

                <OENavigationViewComponent
                    navigationController={this.props.navigationController}
                    compId={'help_' + OEFNHelpEntryType.advice}
                    deferred={true}
                >
                    <OEFNHelpAdvice
                        appComponent={this.props.appComponent}
                        moduleId={this.props.moduleId}
                        navigationController={this.props.navigationController}
                        locStringPrefix={this.props.locStringPrefix}
                    />
                </OENavigationViewComponent>

                <OENavigationViewComponent
                    navigationController={this.props.navigationController}
                    title={this.props.locStringPrefix + 'help_view_videos'}
                    compId={'help_' + OEFNHelpEntryType.videoTutorials}
                    deferred={true}
                >
                    <OEFNHelpVideos
                        appComponent={this.props.appComponent}
                        moduleId={this.props.moduleId}
                        navigationController={this.props.navigationController}
                        locStringPrefix={this.props.locStringPrefix}
                    />
                </OENavigationViewComponent>

                <OENavigationViewComponent
                    navigationController={this.props.navigationController}
                    compId={'help_' + OEFNHelpEntryType.quickStart}
                    deferred={true}
                >
                    <OEFNHelpHandling
                        appComponent={this.props.appComponent}
                        moduleId={this.props.moduleId}
                        navigationController={this.props.navigationController}
                        locStringPrefix={this.props.locStringPrefix}
                    />
                </OENavigationViewComponent>

                <OEPDFModal
                    moduleId={this.props.moduleId}
                    ref={this.onPDFViewRef}
                />
            </React.Fragment>
        );
    }

    postNotificationItemClick(entryType)  {
        if(!this.oe.isReady())  return;

        let userInfo = new this.oe.Module.Dictionary();
        this.oe.sharedInterface.postNotification(this.oe.NotificationName.uiInstanceHelpViewEntryClicked, userInfo.setStringValue('entryType', entryType));
        userInfo.delete();
    }

    onItemClick(id, sender) {
        this.postNotificationItemClick(id);

        let si = this.oe.sharedInterface;

        if(id === OEFNHelpEntryType.advice)   {

            this.props.navigationController.push('help_' + OEFNHelpEntryType.advice);

        } else if(id === OEFNHelpEntryType.email)   {

            let link = sender.props.userData.linkId && this.oe.isReady() ? si.getLocalizedStringEnc(sender.props.userData.linkId) : sender.props.userData.link;
            /*
            let mail = document.createElement('a');
            mail.href = 'mailto:' + link;
            mail.click();
            */

            window.location.href = 'mailto:' + link;

        } else if(id === OEFNHelpEntryType.website)   {

            let link = sender.props.userData.linkId && this.oe.isReady() ? si.getLocalizedStringEnc(sender.props.userData.linkId) : sender.props.userData.link;
            window.open('https://' + link);

        } else if(id === OEFNHelpEntryType.manual)   {
            if(!this.props.appComponent) return;
            
            let options = {
                title:          sender.props.userData.viewTitle,
                titleId:        sender.props.userData.viewTitleId,
                link:           sender.props.userData.link ? sender.props.userData.link : OEManualViewLinks.app,
            };

            if(Array.isArray(this.props.manualViewLinks))   options.links = this.props.manualViewLinks;

            this.props.appComponent.uiLayer.manualView.setOpen(true, options);

        } else if(id === OEFNHelpEntryType.manualInteractive)   {
            if(!this.props.appComponent) return;
            
            this.props.appComponent.app.changeTarget(OETarget.effigosExplorerHelp, (result, oe) => {
                if(!this.oe.isReady() || !(this.props.appComponent && this.props.appComponent.mediaCenter))  return;
                let si = this.oe.sharedInterface;
                let mc = si.getUIControllerMediaCenter();

                let category = mc.getCategoryIndexForName('Presentations');
                if(category >= 0)   {
                    mc.setActualCategory(category);
                } else {
                    console.log('Error - Could not find media center category for name - Presentations');
                }

                let id = mc.getIDForName('help-pres');

                if(id.id >= 0)  {
                    mc.setActualMediaItemID(id.id);
                } else {
                    console.log('Error - Could not find media center item for name - help-pres');
                }

                // set ui visible after setActualMediaItemID due to analytics tracker "presentationInMediaCenterSelected" event trigger
                this.props.appComponent.mediaCenter.updateState();  // make sure changes of actives are allready applied before opening
                this.props.appComponent.mediaCenter.setOpen(true);

                if(this.props.appComponent.app && this.props.appComponent.app.config && this.props.appComponent.app.config.module.uiLayerConfig.widgetConfig.bottomWidgetToolbar.enabled)   {
                    this.props.appComponent.mediaCenter.play(true);
                }
            });

            if(this.props.parent)   this.props.parent.setOpen(false);
            
        } else if(id === OEFNHelpEntryType.videoTutorials)   {

            this.props.navigationController.push('help_' + OEFNHelpEntryType.videoTutorials);

        } else if(id === OEFNHelpEntryType.quickStart)   {

            this.props.navigationController.push('help_' + OEFNHelpEntryType.quickStart);

        } else if(id === OEFNHelpEntryType.tutorReset)   {
            if(!this.oe.isReady()) return;

            this.oe.sharedInterface.getUIControllerTutor().reset();

        } else if(id === OEFNHelpEntryType.disableTutor)   {
            if(!this.oe.isReady()) return;
            
            this.oe.sharedInterface.getUIControllerTutor().popAllChapters();
            this.oe.sharedInterface.getUIControllerTutor().setEnabled(false);

        } else if(id === OEFNHelpEntryType.usageRights)   {

            if(this.pdfViewRef) this.pdfViewRef.setOpen(true, {className: 'usage-rights', titleID: 'usage_rights_pdf_view', pdfURL_ID: 'usage_rights', downloadName: 'licensingTerms.pdf'});

        } else if(id === OEFNHelpEntryType.licenseAgreement)   {

            if(this.pdfViewRef) this.pdfViewRef.setOpen(true, {className: 'license-agreement', titleID: 'license_agreement_pdf_view', pdfURL_ID: 'license_agreement', downloadName: 'licensingTerms.pdf'});
        }
    }

    onItemSubClick(id, sender) {
        if(id === OEFNHelpEntryType.email)   {
            let link = sender.props.userData.linkId && this.oe.isReady() ? this.oe.sharedInterface.getLocalizedStringEnc(sender.props.userData.linkId) : sender.props.userData.link;

            let userNotification = this.props.appComponent ? this.props.appComponent.userNotification : undefined;

            OEClipboard.copyText(link).then(() => {
                if(userNotification)    userNotification.pushMessageId('user_notification_email_copied_to_clipboard', 'Email was copied to clipboard.');
            }, () => {
                if(userNotification)    userNotification.pushMessageId('user_notification_email_copied_to_clipboard_failed', 'Could not copy email to clipboard.', OEUserNotificationStyle.alert);
            });
        }
    }
}

OEFNHelp.defaultProps = {
    moduleId:           '',
    locStringPrefix:    '',
    entries:            OEFNHelpEntryFactory.buildDef(),
    autoSpacerHeight:   '2.125em',            //34,
    version:            false,
    versionForDev:      false,
    devFeatures:        false
};

OEFNHelp.propTypes = Object.assign({
    moduleId:           PropTypes.string
}, OEFNHelpPropTypes.propTypes);